import { render, staticRenderFns } from "./OwnersAssociationNav.vue?vue&type=template&id=47907eb8&web=true&"
import script from "./OwnersAssociationNav.vue?vue&type=script&lang=js&"
export * from "./OwnersAssociationNav.vue?vue&type=script&lang=js&"
import style0 from "./OwnersAssociationNav.vue?vue&type=style&index=0&id=47907eb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports